import cn from "classnames";
import { TbArrowLeft, TbPlus, TbSend } from "react-icons/tb";
import type { SubmitResponseBody } from "shared";
import { LabelButton } from "@/common/LabelButton";
import { Button } from "@/components/Button";
import { NumberInput } from "@/components/form/NumberInput";
import { TextField } from "@/components/form/TextField";
import { useSubmit } from "@/submit/SubmitProvider";
import pageStyles from "../PageSubmit.module.css";
import styles from "./SubmitConfirm.module.css";

function concatName(
  borrower: SubmitResponseBody["extracted"]["borrowers"][number],
) {
  return [borrower.firstName, borrower.lastName].filter((x) => x).join(" ");
}

export function SubmitConfirm() {
  const { form, back, handleSubmit, response, setName, pov } = useSubmit();
  const { control, watch } = form;

  const firstName = watch("borrower.firstName");
  const lastName = watch("borrower.lastName");

  return (
    <form onSubmit={handleSubmit}>
      <h2 className={pageStyles.heading}>Who should we send the offers to?</h2>
      <div className={styles.name}>
        <TextField
          control={control}
          placeholder="First name"
          name="borrower.firstName"
          label={pov === "customer" ? "Your first name" : "First name"}
        />
        <TextField
          control={control}
          placeholder="Last name"
          name="borrower.lastName"
          label={pov === "customer" ? "Your last name" : "Last name"}
        />
      </div>
      {response && response.extracted.borrowers.length > 1 && (
        <div className={cn(styles.prefill, "mb-3")}>
          Prefill:
          <div className={styles.prefillLabels}>
            {response.extracted.borrowers.map((x) => (
              <LabelButton
                key={concatName(x)}
                onClick={() => setName(x)}
                selected={concatName(x) === concatName({ firstName, lastName })}
              >
                {concatName(x)}
              </LabelButton>
            ))}
          </div>
        </div>
      )}
      <TextField
        control={control}
        placeholder="Email"
        type="email"
        name="borrower.email"
        label={pov === "customer" ? "Your email" : "Email"}
      />
      <NumberInput
        control={control}
        placeholder="Credit Score (approximate score is fine)"
        name="borrower.creditScore"
        label={pov === "customer" ? "Your credit score" : "Credit Score"}
      />
      <div className={pageStyles.actions}>
        <Button icon={TbArrowLeft} onClick={back} variant="ghost">
          Back
        </Button>
        <Button
          icon={pov === "customer" ? TbSend : TbPlus}
          type="submit"
          loading={form.formState.isSubmitting}
          disabled={!form.formState.isValid}
        >
          {pov === "customer" ? "Send request" : "Create"}
        </Button>
      </div>
    </form>
  );
}
